import { IconProps } from './iconTypes';

export const KeyboardArrowUp = ({ color, ...props }: IconProps): JSX.Element => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill={color} d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </svg>
);
